export default __webpack_public_path__ + "static/media/two-brex.2380ec7b.png";